import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=64325716"
import script from "./AuthStatus.vue?vue&type=script&lang=js"
export * from "./AuthStatus.vue?vue&type=script&lang=js"
import style0 from "./AuthStatus.vue?vue&type=style&index=0&id=64325716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports